import React, { useState, useEffect, useRef } from "react";
import { withTranslation } from "react-i18next";
import { useHistory, useLocation } from "react-router-dom";
import { Icon } from "antd";
import EventBar from "../../components/EventBar/EventBar";
import useShipments from "../../hooks/useShipments";
import ShipmentContentData from "../../components/ShipmentContentData/ShipmentContentData";
import {
  saveLastListUrl,
  readLastListUrl,
  referrerPath,
} from "../../utils/navOrigin";
import { Link } from "react-router-dom/cjs/react-router-dom.min";

function Shipment() {
  let search = window.location.search;
  let params = new URLSearchParams(search);
  let shipmentCode = params.get("shipmentCode");
  const stepsRef = useRef();

  const history = useHistory();
  const { state } = useLocation();

  const {
    singleShipmentData,
    fetchSingleShipment,
    telemetryInfo,
    alertsListInfo,
    chartsInfo,
    eventsInfo,
  } = useShipments();

  const [shipmentParameters, setShipmentParameters] = useState({
    current: 0,
    status: "loading",
    statusCode: 0,
    file: "",
    standalone: false,
    redirect: false,
    message: "Cargando...",
    shipmentCode: shipmentCode,
    telemetryTypeCode: null,
    imei: null,
    macMando: null,
    numRefClient: null,
    destinationData: {},
  });

  const [backUrl, setBackUrl] = useState("/");

  useEffect(() => {
    const getShipment = async () => {
      const fetchData = await fetchSingleShipment(shipmentCode);
    };

    getShipment();
  }, []);

  useEffect(() => {
    const fromState = state?.from || null;
    if (fromState) {
      saveLastListUrl(fromState);
      setBackUrl(fromState);
      return;
    }
    const fromSession = readLastListUrl();
    if (fromSession) {
      setBackUrl(fromSession);
      return;
    }
    const fromReferrer = referrerPath();
    if (fromReferrer) {
      saveLastListUrl(fromReferrer);
      setBackUrl(fromReferrer);
      return;
    }
    setBackUrl("/");
  }, [state]);

  const handleBack = () => {
    if (backUrl) history.push(backUrl);
    else if (history.length > 1) history.goBack();
    else history.push("/");
  };

  useEffect(() => {
    if (singleShipmentData.statusCode === 0) {
      setShipmentParameters((prevState) => ({
        ...prevState,
        message: "Cargando",
        status: "loading",
        statusCode: 0,
      }));
      return false;
    }

    if (singleShipmentData.statusCode !== 200) {
      return setShipmentParameters((prevState) => ({
        ...prevState,
        message: singleShipmentData.message,
        statusCode: singleShipmentData.statusCode,
        status: "loaded",
      }));
    }

    if (singleShipmentData.statusCode === 200) {
      setShipmentParameters((prevState) => ({
        ...prevState,
        file: singleShipmentData.file,
        standalone: singleShipmentData.standAlone,
        statusCode: singleShipmentData.statusCode,
        status: "loaded",
        telemetryTypeCode: singleShipmentData.telemetryTypeCode,
        imei: singleShipmentData.imei,
        macMando: singleShipmentData.macMando,
        numRefClient: singleShipmentData.numRefClient,
        destinationData: singleShipmentData.destinationData,
      }));
    }
  }, [singleShipmentData]);

  return (
    <div className="Envio">
      <div style={{ marginBottom: 24 }}>
        <Link onClick={handleBack}>
          <Icon type="arrow-left" /> Atrás
        </Link>
      </div>
      <EventBar
        shipmentCode={shipmentParameters.shipmentCode}
        eventsInfo={eventsInfo}
        stepsRef={stepsRef}
      />
      <ShipmentContentData
        shipmentParameters={shipmentParameters}
        telemetryInfo={telemetryInfo}
        alertsListInfo={alertsListInfo}
        chartsInfo={chartsInfo}
        stepsRef={stepsRef}
      />
    </div>
  );
}

export default withTranslation()(Shipment);
